<template>
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      {{ $t("delaysList.headline") }}
    </div>
    <ul class="list-group list-group-flush">
      <template
        v-for="(timeSheet, timeSheetIndex) in timeSheets"
        :key="`timeSheet.d.${timeSheetIndex}`"
      >
        <li
          class="list-group-item disabled bg-light p-1 px-3"
          v-if="timeSheet.delays.length > 0 && timeSheets.length > 1"
        >
          {{ timeSheet.title }}
        </li>
        <li
          :class="`list-group-item d-flex justify-content-between align-items-start ${
            $root.can('delays:manage')
              ? 'clickable  list-group-item-action'
              : ''
          }`"
          v-for="(delay, delayIndex) in timeSheet.delays"
          :key="delayIndex"
          @click="onClick($event, delay)"
        >
          <div class="me-auto">
            <div class="fw-bold">{{ delay.reason }}</div>
            {{ delay.pausedAtFormatted }} ({{ delay.durationMillis / 60000 }}
            {{ $t("delaysList.minutes") }})
          </div>
          <span class="badge bg-danger rounded-pill">{{ delay.userName }}</span>
        </li>
      </template>
      <li
        class="list-group-item d-flex justify-content-between align-items-start"
        v-if="$root.can('delays:manage')"
      >
        <div class="mx-auto">
          <button
            type="button"
            class="btn btn-outline-danger"
            @click="onOpen($event)"
          >
            {{ $t("general.add", { item: $t("general.delay") }) }}
          </button>
        </div>
      </li>
      <li
        class="list-group-item d-flex justify-content-between align-items-start"
        v-if="!$root.can('delays:manage') && delays.length == 0"
      >
        <div class="mx-auto">
          <span>{{ $t("delaysList.empty") }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    timeSheets: Array,
    onClick: Function,
    onOpen: Function,
  },
  computed: {
    refereeDecisions() {
      return [].concat(
        ...this.timeSheets?.map((timeSheet) => timeSheet.refereeDecisions ?? [])
      );
    },
  },
  methods: {},
});
</script>
